@if (items) {
  <div class="ion-padding-top">
    <ion-text color="medium">
      <h6>Latest servings</h6>
    </ion-text>
    <ion-card class="ion-no-padding ion-no-margin" color="light">
      <ion-card-content class="ion-no-padding">
        @for (item of items; track identify($index, item)) {
          <ion-item lines="full" color="light">
            <ion-icon name="calendar-number-outline" slot="start"></ion-icon>
            <ion-label>
              {{ dateHelper.calendar(item.uDate) }}
              <div class="ps-badge-list">
                @if (item.beverage === 'Beer') {
                  <ion-badge>
                    <ion-icon name="beer-outline" color="secondary"></ion-icon>
                    {{ item.name }}
                  </ion-badge>
                }
              </div>
            </ion-label>
            @if (units) {
              <ion-text slot="end" color="medium">
                {{
                unitsHelper.toUnit(item.amount, "ml", units.pour, -1)
                | number : "1.2-2"
                }}
                {{ units.pour }}
              </ion-text>
            }
          </ion-item>
        }
      </ion-card-content>
    </ion-card>
  </div>
}